var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 184,
    viewBox: "0 0 172 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.797 178.453C115.644 184.094 115.913 108.203 117.366 82.259C117.372 82.181 117.315 82.113 117.236 82.106C117.158 82.098 117.087 82.155 117.076 82.233C114.772 100.691 108.789 138.311 94.7444 140.089C89.1954 140.778 71.6524 141.135 62.2914 79.662C62.2774 79.585 62.2054 79.534 62.1274 79.545C62.0494 79.556 61.9934 79.626 61.9994 79.705C64.8234 123.376 67.0324 183.07 36.2364 183.109C-20.7166 183.181 -6.79156 -1.39999 51.9184 0.0080145C75.0194 0.563015 91.7224 24.84 96.8684 56.238C100.107 26.539 119.914 11.691 140.139 17.745C175.195 29.482 186.796 170.535 145.797 178.453Z",
    fill: "#D5FF18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.191157dcfd15cdc4f5c7a9833e5c5c54.svg";
export { ForwardRef as ReactComponent };